import {ReactNode} from "react";
import {Box} from "@mui/material";
import {createStyles, makeStyles} from "@mui/styles";
import {Theme} from "@mui/material/styles";
import CommonCssStyles from "../../css/CommonCssStyles";
import Divider from "@mui/material/Divider";


export interface PageHeaderProps {
    children: ReactNode | ReactNode[];
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        headerPageSegment: CommonCssStyles.getHeaderPageSegmentStyles(theme),
    })
);

export default function PageHeader({children}: Readonly<PageHeaderProps>) {
    const classes = useStyles();

    return (
        <>
            <Box className={classes.headerPageSegment}>
                {children}
            </Box>
            <Divider/>
        </>
    );
}